import { routes } from "@/global/routes";
import {
  faqs,
  howItWorks,
  CheckoutTerms,
  RegistrationTerms,
  redeemGiftCardLanguages,
  purchaseGiftCardLanguages,
  CheckoutSuccessDescription,
} from "./helpers";
import { vendorUUIDs } from "../../constants";

import GiftCardBanner from "@/assets/images/brandedCalloutBg.jpg";
import MobileFindGamesBanner from "public/images/magic/mobile-banner.jpg";
import FindGamesBanner from "public/images/magic/magic_ChooseYourGamesBanner.jpeg";

import type { TeamConfig } from "@/global/hooks/useTeamConfig";
import Link from "next/link";
import { useRouter } from "next/router";

const config: TeamConfig = {
  teamSchema: "flex_sandbox_groups",
  browserTitle: "Flex Sandbox",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  teamName: "Flex Sandbox",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-10215-devils-sec",
    mapId: "main",
    isGroupTicketSeatMapEnabled: true,
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: true,
    isLandingPageGiftCardEnabled: true,
    isStandalonePageGiftCardEnabled: true,
    redirectGiftCardUrl: routes.giftCard,
  },

  // disabled routes
  disabledRoutes: [],

  phoneNumber: "",

  checkoutCreditPackages: false,
  availableCreditEnabled: false,
  isCrowdHandlerEnabled: false,
  inventoryType: "GROUP-LEVEL",

  // purchase seat configs
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    maxGameSelectionCount: 2,
    minSeatLimit: 2,
    defaultSeatCount: 20,
    isSimilarSeatForAllEvents: false,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: true,
    isDiffSeatAlertEnabled: false,

    // show additional details fields at checkout form
    isCheckoutAdditionalDetailsEnabled: false,
    showFrontendTotalAmount: false,
    showFrontendServiceFee: false,

    isPerksEnabled: false,

    isTicketTransferEnabled: true,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: true,
    isStandAlonePurchaseCreditEnabled: true,
    showPurchaseCreditLinkInHomeMenu: true,
    isPurchaseCreditHistoryEnabled: false,
    checkoutTimerEnabled: false,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: false,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: 3,
    allowedPaymentFailCount: 3,
  },
  isSaveCardAllowed: false,

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
  },

  // call refresh inventory when selecting games
  refreshInventoryWhenEventClick: false,

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/baabal/",

  // vendor
  platform: vendorUUIDs.ticketmaster,

  // okta config
  oktaIssuer: "",
  oktaClientId: "",

  images: {
    findGamesBannerImage: FindGamesBanner.src,
    authBackgroundImage: "",
    checkoutStatusPageImage: "",
    //TODO: update const to the other teams
    giftCardStandalonePageImage: GiftCardBanner.src,
    logoImage:
      "http://ss-leagues.s3.amazonaws.com/NBA/Updated%20NBA%20Logos/orl.png?width=76&height=76",
    logoNameImage: "",
    faviconImage: "",
    seatMap3dPreviewImage: "",
    mobileFindGamesBannerImage: MobileFindGamesBanner.src,
  },

  colors: {
    primary: "#0077c0",
  },

  howItWorks,
  faqs,

  uiConfigs: {
    bannerImage: {
      title: "Choose Your Games",
      isBackgroundBasedBanner: true,
    },
    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: false,
    },

    bottomBar: {
      showGameSelectionProgress: false,
    },

    inventoryCardSettings: {
      hideFBPackageLineItem: true,
    },
  },

  languages: {
    topNavMenuItems: <></>,
    checkoutTermsAndCondition: <CheckoutTerms />,
    registrationTermsAndCondition: <RegistrationTerms />,
    purchaseSeats: null,
    purchaseGiftCard: purchaseGiftCardLanguages,
    redeemGiftCard: redeemGiftCardLanguages,
    checkoutSuccessMessage: " ",
    checkoutSuccessDescription: <CheckoutSuccessDescription />,
    gameFilters: {
      seatCounter: {
        description:
          "Select the number of people in you group. Minimum of 20 required",
      },
      priceRange: {
        title: "Price Range per Ticket",
      },
    },

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description:
              "If an intended recipient is not specified, once purchased, you will have to forward the unique code to the recipient. Upon your recipient receiving their gift card, they will be prompted to enter their unique code to redeem the gift card. They can use the gift card for all events at the Hippodrome Broadway Series in Baltimore, Maryland.",
          },
          sendNowTrue: {
            description:
              "The Recipient will be sent an email with the unique code for them to redeem their gift card. They can use the gift card for all events at the Hippodrome Broadway Series in Baltimore, Maryland.",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description:
            "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster account above.",
        },
        logout: {
          description:
            "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster.",
        },
        success: {
          description: "has been added to to your account!",
        },
      },
    },
    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
